<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px">
            <!-- Card header -->
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row">
                <div class="col-2">
                  <h5 class="mb-0">My Notification</h5>
                </div>
                <div class="col-8">
                  <input v-model="table.search" class="form-control rounded-pill text-center" type="text"
                    placeholder="Search Notification" @keyup="filter" />
                </div>
                <div class="col-2">
                  <div class="my-auto ms-auto float-end">
                    <button type="button" class="mx-1 mb-0 btn bg-gradient-dark btn-sm" @click="markAllAsRead">
                      Read All
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Card Body -->
            <div style="height: 500px; overflow-y: auto;">
              <DataTable
                :value="table.onLoad ? dummyRows : table.data"
                removable-sort
                scrollable
                scroll-height="flex"
                table-style="min-width: 50rem"
                class="text-sm"
              >
                <Column field="sender" header="Sender" header-class="bg-light text-dark" sortable>
                  <template v-if="table.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <div>{{ getNotificationField(slotProps.data, 'sender') }}</div>
                  </template>
                </Column>
                <Column field="message" header="Message" header-class="bg-light text-dark" sortable>
                  <template v-if="table.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <div>{{ getNotificationField(slotProps.data, 'message') }}</div>
                  </template>
                </Column>
                <Column field="read_at" header="Read At" header-class="bg-light text-dark" sortable>
                  <template v-if="table.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <div>{{ formatDate(slotProps.data.read_at) }}</div>
                  </template>
                </Column>
                <Column header="Action" header-class="bg-light text-dark" :style="{ width: '120px' }"
                  :body-style="{ width: '120px', padding: '0' }">
                  <template v-if="table.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="slotProps">
                    <div class="dropdown text-center">
                      <a :id="'dropdownNotifications' + slotProps.data.id" href="#" class="cursor-pointer"
                        data-bs-toggle="dropdown" aria-expanded="false" role="button">
                        <i class="fa fa-ellipsis-v text-secondary"></i>
                      </a>
                      <ul data-popper-placement="bottom-start"
                        class="dropdown-menu dropdown-menu-end px-2 py-3"
                        :aria-labelledby="'dropdownNotifications' + slotProps.data.id">
                        <li>
                          <a class="dropdown-item border-radius-md" href="#"
                            @click="viewDetails(slotProps.data.id)">
                            View Details
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item border-radius-md" href="#"
                            @click="markAsRead(slotProps.data.id)">
                            Read
                          </a>
                        </li>
                      </ul>
                    </div>
                  </template>
                </Column>
                <template #empty>
                  <div style="text-align: center; padding: 40px 0;">
                    <div style="color: #888; font-size: 1.1em; font-weight: 500;">No Data</div>
                  </div>
                </template>
              </DataTable>
            </div>
            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination v-model="table.page.current_pages" :page-count="table.page.last_page || 1" size="sm"
                  @click="changePage" />
              </span>
              <span class="float-end">
                {{
                  (table.page.current_pages - 1) * (table.page.per_page || 10) + table.data.length
                }}
                of {{ table.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Details -->
    <div id="modalDetails" class="modal fade" tabindex="-1" aria-hidden="true" @click.self="closeModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modal.title }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <label>Sender</label>
            <input v-model="modal.data.sender" type="text" placeholder="Sender" class="form-control" readonly />
            <label class="mt-3">Message</label>
            <textarea v-model="modal.data.message" placeholder="Message" rows="4" class="form-control"
              readonly></textarea>

            <label class="mt-3">Read At</label>
            <input v-model="modal.data.read_at" type="text" placeholder="Read At" class="form-control" readonly />

            <label class="mt-3">Created At</label>
            <input v-model="modal.data.created_at" type="text" placeholder="Created At" class="form-control" readonly />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn bg-gradient-danger btn-sm" @click="closeModal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination.vue";
import myNotificationService from "@/services/dashboards/myNotificationService";
import moment from "moment";

export default {
  components: {
    BasePagination,
  },
  data() {
    return {
      loadTimeout: null,
      dummyRows: Array.from({ length: 10 }, () => ({})),
      table: {
        onLoad: true,
        search: this.$route.query.search || "",
        total: 0,
        data: [],
        page: {
          current_pages: 1,
          last_page: 1,
          per_page: 5,
        },
      },
      modal: {
        title: "Notification Details",
        data: {
          sender: "",
          message: "",
          read_at: "",
          created_at: "",
        },
      },
    };
  },
  watch: {
    "table.page.current_pages": {
      handler() {
        this.get();
      },
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    async get() {
      this.table.onLoad = true;
      try {
        const response = await myNotificationService.list(this.table.page.current_pages, {
          limit: 5,
          search: this.table.search,
        });

        const apiData = response?.data?.data || {};
        this.table.data = apiData.data || [];
        this.table.total = apiData.total || 0;
        this.table.page.last_page = apiData.last_page || 1;
        this.table.page.per_page = apiData.per_page || 10;
      } catch (error) {
        console.error("❌ Error fetching notifications:", error);
        this.table.data = [];
      } finally {
        this.table.onLoad = false;
      }
    },

    filter() {
      clearTimeout(this.loadTimeout);
      this.loadTimeout = setTimeout(() => {
        const searchQuery = this.table.search;
        if (searchQuery === "") {
          this.$router.push({ name: 'My Notification', params: { moduleSlug: 'material-management' }, query: null });
        } else {
          this.$router.push({ name: 'My Notification', params: { moduleSlug: 'material-management' }, query: { search: searchQuery } });
        }
        this.get();
      }, 500);
    },

    closeModal() {
      const modalEl = document.getElementById("modalDetails");
      if (modalEl) {
        modalEl.classList.remove("show");
        modalEl.style.display = "none";
        document.body.classList.remove("modal-open");
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) backdrop.remove();
      }
    },

    async markAllAsRead() {
      try {
        const result = await this.confirmDialog("You won't be able to revert this!", "read all");
        if (result.isConfirmed) {
          await myNotificationService.readAll();
          this.get();
        }
      } catch (error) {
        console.error("Error marking all as read:", error);
      }
    },

    async markAsRead(id) {
      try {
        const result = await this.confirmDialog("You won't be able to revert this!", "read it");
        if (result.isConfirmed) {
          await myNotificationService.read(id);
          this.get();
        }
      } catch (error) {
        console.error("Error marking as read:", error);
      }
    },

    async viewDetails(id) {
      try {
        const response = await myNotificationService.detail(id);
        const notif = response?.data?.data;

        if (!notif) {
          console.warn("Notification not found");
          return;
        }

        // Parse safely
        let parsedData = {};
        if (notif.data && typeof notif.data === "string") {
          try {
            parsedData = JSON.parse(notif.data);
          } catch (e) {
            console.warn("Invalid JSON in notification data:", notif.data);
          }
        }

        this.modal.data = {
          sender: parsedData.sender || "System",
          message: parsedData.message || "No message content.",
          read_at: notif.read_at ? moment(notif.read_at).format("DD/MM/YYYY HH:mm") : "Not read yet",
          created_at: notif.created_at ? moment(notif.created_at).format("DD/MM/YYYY HH:mm") : "—",
        };

        // Show modal
        const modalEl = document.getElementById("modalDetails");
        modalEl.style.display = "block";
        modalEl.classList.add("show");
        document.body.classList.add("modal-open");
      } catch (error) {
        console.error("Error fetching notification details:", error);
      }
    },

    changePage() {
      clearTimeout(this.loadTimeout);
      this.loadTimeout = setTimeout(() => {
        this.get();
      }, 100);
    },

    formatDate(dateString) {
      if (!dateString) return "UNREAD";
      return moment(dateString).format("DD/MM/YYYY HH:mm");
    },

    // ✅ Safe helper to extract field from notification.data
    getNotificationField(notification, field) {
      const rawData = notification?.data;

      // If data is missing or not a string, return fallback
      if (!rawData || typeof rawData !== "string") {
        if (field === "sender") return "System";
        if (field === "message") return "No message content.";
        return "—";
      }

      try {
        const parsed = JSON.parse(rawData);
        return parsed[field] || "—";
      } catch (e) {
        console.warn("Failed to parse notification data:", rawData);
        return field === "sender" ? "Unknown" : "Invalid format";
      }
    },
  },
};
</script>

<style scoped></style>